// extracted by mini-css-extract-plugin
export default {"main":"product_main__Z6w3r","title":"product_title__Ux7wk","card":"product_card__pCQ-4"};